import { render, staticRenderFns } from "./ImageEditorDirect.vue?vue&type=template&id=53d071da&"
import script from "./ImageEditorDirect.vue?vue&type=script&lang=js&"
export * from "./ImageEditorDirect.vue?vue&type=script&lang=js&"
import style0 from "./ImageEditorDirect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports